import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { AngularEditorComponent, AngularEditorConfig } from "@kolkov/angular-editor";
import { constantUrl } from "src/app/Shared/constantUrl";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { IsFocusableConfig } from "@angular/cdk/a11y";

declare var $: any;

class MyUploadAdapter {
  searchText: string = "";
  loader: any;

  constructor(loader: any) {
    this.loader = loader;
  }

  upload() {
    return this.loader.file.then(
      (file: File) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          const data: any = {
            DocName: file.name,
          };

          reader.onload = () => {
            data.DocData = (reader.result as string).split(";base64,").pop();
            this.uploadFile(resolve, reject, data);
          };

          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        }),
    );
  }

  uploadFile(resolve: any, reject: any, data: any) {
    $.ajax({
      url: `${constantUrl.apiEndpointUploadDoc}/api/UploadDoc/UploadTemplateDoc`,
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(data),
      success: (result: string) => {
        const fullUrl = constantUrl.SenctionTemplateImageUrl + result;
        resolve({ default: fullUrl });
      },
      error: (xhr, status, error) => {
        reject(`Couldn't upload file: ${data.DocName}`);
      },
    });
  }
}

function MyCustomUploadAdapterPlugin(editor: any) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader: any) => {
    return new MyUploadAdapter(loader);
  };
}

@Component({
  selector: "app-email-letter-template",
  templateUrl: "./email-letter-template.component.html",
  styleUrls: ["./email-letter-template.component.scss"],
})
export class EmailLetterTemplateComponent implements OnInit {
  selectedPlatform: "facebook" | "linkedin" | "instagram" | "twitter" | null =
    null;
  Link: string = "";
  BasePath: any = constantUrl.apiProfilePicUrl;
  CompanyLogo: any = "logo.png";
@ViewChild('editor') editor!: AngularEditorComponent;
@ViewChild('f') f: NgForm;

  currentUser: any;
  showSpinner: boolean = false;
  templateData: string = "";
  loading: boolean = false;

  AddType: string = "";
  TemplateId: any = "";
  TemplateName: string = "";
  Subject: string = "";
  TemplateDropdown: any[] = [];
  JsonData: any[] = [];
  searchText: string = "";

  form: FormGroup;

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  config2: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    minHeight: "500px",
    maxHeight: "500px",
    placeholder: "Enter email body here...",
    translate: "no",
    sanitize: false,
    toolbarPosition: "top",
    defaultFontName: "Arial",
    defaultFontSize: "3",
    defaultParagraphSeparator: "p",
    customClasses: [
      { name: "quote", class: "quote" },
      { name: "redText", class: "redText" },
      { name: "titleText", class: "titleText", tag: "h1" },
    ],
  };

  constructor(
    private formBuilder: FormBuilder,
    private dataSharingService: DataSharingService,
    private _MasterService: MasterService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      signature: ["", Validators.required],
    });

    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser")!);
    this.dataSharingService.LOSHeaderTitle.next("Customer Email Template");

    this.GetTemplateList();
    this.getTemplateSideMenu();
  }

  OnChangeType() {
    this.templateData = "";
    this.Subject = "";
    this.TemplateId = "";
    this.TemplateName = "";

    if (this.AddType === "Modify") {
      this.GetTemplateList();
    }
  }

  GetTemplateList() {
    this.showSpinner = true;
    this._MasterService.Get_Mail_Template({
      IsForCustomer: 1,
    }).subscribe({
      next: (result: any) => {
        this.TemplateDropdown = result || [];
        this.showSpinner = false;
      },
      error: () => {
        this.showSpinner = false;
      },
    });
  }
AddCompanyLogo() {
  if (!this.editor) return;

  const imageUrl = this.BasePath + this.CompanyLogo;

  const html = `
<span style="display:none!important; visibility:hidden; opacity:0; height:0; width:0; overflow:hidden; mso-hide:all;">
.
</span>
<table align="center" cellpadding="0" cellspacing="0" border="0">
  <tr>
    <td align="center">
      <img 
        src="${imageUrl}" 
        width="120"
        style="display:block; border:0; outline:none; text-decoration:none;"
        alt="Company Logo"
      />
    </td>
  </tr>
</table>
<br>
`;

  this.editor.executeCommand('insertHtml', html);
}

onsaveLink(Link: string) {
  let html: string = "";
  if (this.selectedPlatform === "facebook") {
    html = `
      <a href="${Link}" target="_blank">
        <img
          src="https://cdn-icons-png.flaticon.com/512/15047/15047435.png"
          width="22"
          height="22"
          style="vertical-align:middle;border:none;"
          alt="Facebook"
        />
      </a>
    `;
  } else if (this.selectedPlatform === "linkedin") {
    html = `
      <a href="${Link}" target="_blank">
        <img
          src="https://cdn-icons-png.flaticon.com/512/174/174857.png"
          width="22"
          height="22"
          style="vertical-align:middle;border:none;"
          alt="LinkedIn"
        />
      </a>
    `;
  } else if (this.selectedPlatform === "instagram") {
    html = `
      <a href="${Link}" target="_blank">
        <img
          src="https://cdn-icons-png.flaticon.com/512/1384/1384031.png"
          width="22"
          height="22"
          style="vertical-align:middle;border:none;"
          alt="Instagram"
        />
      </a>
    `;
  } else if (this.selectedPlatform === "twitter") {
    html = `
      <a href="${Link}" target="_blank"
         style="text-decoration:none; display:inline-block; margin-right:6px;">
        <img
          src="https://img.icons8.com/ios-filled/50/000000/twitterx.png"
          width="22"
          height="22"
          style="vertical-align:middle;border:none;"
          alt="Twitter/X"
        />
      </a>
    `;
  }

  const control = this.form.get("signature");
  const value = control?.value || "";
  control?.setValue(value + html);  // appends the fixed HTML
// this.editor.executeCommand('insertHtml', html);
  this.closeModal();
}

  openLinkModal(platform: "facebook" | "linkedin" | "instagram" | "twitter") {
    this.selectedPlatform = platform;
    this.Link = "";
    ($("#linkModal") as any).modal("show");
  }
  closeModal() {
    this.Link = "";
    this.selectedPlatform = null;
    $("#linkModal").modal("hide");
  }

  getEmailTemplate() {
    if (this.AddType === "Modify" && this.TemplateId) {
      const selected = this.TemplateDropdown.find(
        (x: any) => x.Mail_Template_Id == this.TemplateId,
      );
      this.TemplateName = selected?.StepName || "";
    }

    this._MasterService
      .Get_Mail_Template_Data({ Id: this.TemplateId || 0 })
      .subscribe((res: any) => {
        this.templateData = res[0]?.MailBody || "";
        this.Subject = res[0]?.MailSubject || "";
        setTimeout(() => {
        const div = document.querySelector('.contenteditable-subject') as HTMLDivElement;
        if (div) {
          div.innerHTML = this.Subject; 

        }
      }, 0);
      });
  }

  SaveUpdateTemplate() {
    if (!this.TemplateName.trim()) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Template name is required.",
        ...this.configSuccess,
      });
      return;
    }

    if (!this.Subject.trim()) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Email subject is required.",
        ...this.configSuccess,
      });
      return;
    }

    this.showSpinner = true;
    this.loading = true;

    this._MasterService
      .Save_Mail_Template({
        StepName: this.TemplateName,
        MailSubject: this.Subject,
        LoginUserId: this.currentUser.userId,
        Id: this.TemplateId || 0,
        MailBody: this.templateData,
        IsForCustomer: 1,
      })
      .subscribe((res: any) => {
        if (res[0]?.CODE === 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].Msg,
            ...this.configSuccess,
          });
          this.GetTemplateList();
          this.resetForm();
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0]?.Msg || "Error saving template.",
            ...this.configSuccess,
          });
        }
        this.showSpinner = false;
        this.loading = false;
      });
  }

  resetForm() {
    this.AddType = "";
    this.TemplateId = "";
    this.TemplateName = "";
    this.Subject = "";
    this.templateData = "";
  }

  getTemplateSideMenu() {
    this._MasterService
      .GetTemplate_SideMenu({ ProductId: 0 })
      .subscribe((res: any) => {
        this.JsonData = JSON.parse(JSON.stringify(res || []));
        console.log("Template side menu data:", this.JsonData);
      });
  }

  draggedPlaceholder: string = "";

  onDragStart(event: DragEvent, placeholder: string) {
    this.draggedPlaceholder = placeholder;
    event.dataTransfer?.setData("text/plain", placeholder);
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = "copy";
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.dataTransfer!.dropEffect = "copy";
  }
updateModel(html: string) {
  this.Subject = html;
  
}
 onSubjectDrop(event: DragEvent, target: HTMLElement) {  
  event.preventDefault();
  event.stopPropagation();

  let placeholder = this.draggedPlaceholder || event.dataTransfer?.getData("text/plain");

  if (placeholder) {
    this.insertPlaceholderAtCursor(placeholder.trim(), target);
  }

  this.draggedPlaceholder = "";
}














 private insertPlaceholderAtCursor(placeholder: string, editableDiv: HTMLElement) {
  
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0) return;

  const range = selection.getRangeAt(0);

  
  range.deleteContents();

  
  const textNode = document.createTextNode(placeholder);
  range.insertNode(textNode);

  
  range.setStartAfter(textNode);
  range.setEndAfter(textNode);
  range.collapse(true);  

  
  selection.removeAllRanges();
  selection.addRange(range);

  
  this.Subject = (editableDiv as HTMLDivElement).innerText.trim();

  
  const control = this.f?.controls['Subject'];
  if (control) {
    control.markAsTouched();
    control.markAsDirty();
    control.updateValueAndValidity();
  }
}
  onSubjectInput(event: Event) {
  const div = event.target as HTMLDivElement;

  
  
  this.Subject = div.innerText.trim();

  
  

  
  const control = this.f?.form.get('Subject');
  if (control) {
    control.markAsDirty();
    control.markAsTouched();
    control.updateValueAndValidity();
  }
}

onSubjectBlur() {
  
  const div = document.querySelector('.contenteditable-subject') as HTMLDivElement;
  if (div) {
    if (div.innerHTML === '<br>' || div.innerHTML === '' || div.innerText.trim() === '') {
      div.innerHTML = '';
      this.Subject = '';
    }
  }
}

onSubjectKeydown(event: KeyboardEvent) {
  
  if ((event.metaKey || event.ctrlKey) && !event.shiftKey && !event.altKey) {
    const key = event.key.toLowerCase();

    if (key === 'b') {
      event.preventDefault();
      document.execCommand('bold', false, undefined);
      this.syncSubjectAfterCommand(); 
    }
    else if (key === 'i') {
      event.preventDefault();
      document.execCommand('italic', false, undefined);
      this.syncSubjectAfterCommand();
    }
  }
}


private syncSubjectAfterCommand() {
  setTimeout(() => {
    const div = document.querySelector('.contenteditable-subject') as HTMLDivElement;
    if (div) {
      this.Subject = div.innerText.trim();  
    }
  }, 0);
}

  private insertIntoSubjectAtCursor(
    placeholder: string,
    input: HTMLInputElement,
  ) {
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;

    this.Subject =
      this.Subject.substring(0, start) +
      placeholder +
      this.Subject.substring(end);

    const newPos = start + placeholder.length;
    setTimeout(() => {
      input.focus();
      input.setSelectionRange(newPos, newPos);
    }, 0);
  }
}
